import React from 'react';
import { Box, Button, CircularProgress, Heading, Image, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { userProgressType } from '../../../../hooks/V2/useUserActivity';
import Lottie from 'react-lottie-player';
import successLottie from '../../../assets/lottie/successLottie.json';

interface Props {
	lecture: {
		_id: string;
		image: string;
		title: string;
		tag: string;
		date: string;
		time: string;
		ctaText: string;
	};
	lectureProgress?: userProgressType;
}

const LectureCard = ({ lecture, lectureProgress }: Props) => {
	const currentPath = window.location.pathname;
	const navigate = useNavigate();
	return (
		<Box
			w="full"
			pb="16px"
			maxW="361px"
			display="flex"
			flexDir="column"
			bgColor={'#fff'}
			borderRadius={'12px'}
			border="1px solid #E5E5E5"
			boxShadow={'0px 1px 2px 0px rgba(0, 0, 0, 0.06), 0px 1px 3px 0px rgba(0, 0, 0, 0.10);'}
		>
			<Image w="full" minH="166px" borderTopLeftRadius={'12px'} borderTopRightRadius={'12px'} src={lecture?.image} />
			<Box px="16px" mt="8px" flex="1" display="flex" flexDir="column">
				<Box display="flex" alignItems="center" justifyContent="space-between">
					<Text w="fit-content" textStyle={'body2-md'} color="#4358F6" px="8px" py="4px" borderRadius={'100px'} bgColor={'#F2F6FF'}>
						{lecture?.tag}
					</Text>
					{lectureProgress && lectureProgress?.completionPercentage > 0 ? (
						lectureProgress?.completionPercentage >= 100 ? (
							<Box w="40px" p={''}>
								<Lottie loop animationData={successLottie} play style={{ width: '100%' }} />
							</Box>
						) : (
							<CircularProgress size="30px" value={lectureProgress?.completionPercentage}></CircularProgress>
						)
					) : null}
				</Box>
				<Heading mt="4px" as="h4">
					{lecture?.title}
				</Heading>

				{/* <Box mt="12px" display={'grid'} gap="12px" gridTemplateColumns={'repeat(2,1fr)'}>
					{['date', 'time'].map(item => {
						return (
							<Box display={'flex'} borderRight={item === 'date' ? '1px solid #A5A5A5' : ''}>
								{item === 'date' ? (
									<Image src="https://masai-website-images.s3.ap-south-1.amazonaws.com/Calendar_Check_9d96abee5f.svg" />
								) : (
									<Image src="https://masai-website-images.s3.ap-south-1.amazonaws.com/Clock_5fb04593ce.svg" />
								)}
								<Text fontWeight={600} textStyle={'body2'} fontSize={'12px'} lineHeight={'24px'} ml="6px">
									{item === 'date' ? lecture?.date : lecture?.time}
								</Text>
							</Box>
						);
					})}
				</Box> */}
				<Box mt="auto">
					<Button
						mt="16px"
						onClick={() => {
							// get path and append /lecture
							// redirect to that path
							navigate(`${currentPath}/lecture/${lecture?._id}`);
						}}
						w="100%"
						bgColor={'#4358F6'}
						variant={'primary'}
					>
						{lecture?.ctaText}
					</Button>
				</Box>
			</Box>
		</Box>
	);
};

export default LectureCard;
